import { graphql } from 'gatsby';
import React from 'react';

interface IntroductionProps {
  pre_title: TextStyle;
  title: string;
  text: string;
}

const IntroductionBlock: React.FC<IntroductionProps> = ({
  pre_title,
  title,
  text,
}) => {
  const hasPreTitleGradient = pre_title.gradient
  const preTitleGradient = hasPreTitleGradient ? pre_title.gradient : 'none';

  let preTitleStyle = {
    '--preTitleColor': `${pre_title.color}`,
    '--preTitleGradient': `${preTitleGradient}`,
  } as React.CSSProperties;

  if (hasPreTitleGradient) {
    preTitleStyle = {
      ...preTitleStyle,
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
    } as React.CSSProperties;
  }

  return (
    <div className={`block__introduction`}>
      <div className='col-12 col-md-6'>
        <h4
          className={`introduction__pre-title`}
          style={preTitleStyle}
          dangerouslySetInnerHTML={{ __html: pre_title.text }}
        />
        <h1
          className='introduction__title'
          dangerouslySetInnerHTML={{ __html: title }}
        />
      </div>
      <div className='col-12 col-md-6'>
        <p
          className='introduction__text'
          dangerouslySetInnerHTML={{ __html: text }}
        />
      </div>
    </div>
  );
};

export default IntroductionBlock;

export const introductionFragment = graphql`
  fragment IntroductionFragment on Block {
    pre_title_style {
      text
      color
      gradient
    }
    title
    text
  }
`;
